import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../core/environments/environment';
import { lastValueFrom } from 'rxjs';
import { ListarSistemasModel } from '../models/listar-sistemas.model';
import { FuncionalidadeModel } from '../models/funcionalidade.model';

@Injectable({
  providedIn: 'root',
})
export class SistemaService {
  constructor(private http: HttpClient, private Router: Router) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    withCredentials: true,

  };

  async buscarSistemas(filtros: any): Promise<ListarSistemasModel[]> {
    try {
      return await lastValueFrom(
        this.http.post<ListarSistemasModel[]>(
          `${environment.apiSistema}/findAll`,
          JSON.stringify(filtros),
          this.httpOptions
        )
      );
    } catch (error) {
      return [];
    }
  }
  async buscarFuncionalidades(filtros: any): Promise<FuncionalidadeModel[]> {
    try {
      return await lastValueFrom(
        this.http.post<FuncionalidadeModel[]>(
          `${environment.apiFuncionalidade}/findAll`,
          JSON.stringify(filtros),
          this.httpOptions
        )
      );
    } catch (error) {
      return [];
    }
  }

  async buscarSistemaPorId(id: number): Promise<ListarSistemasModel> {
    try {
      return await lastValueFrom(
        this.http.get<ListarSistemasModel>(`${environment.apiSistema}/findById?id=${id}`, this.httpOptions)
      );
    } catch (error) {
      throw error;
    }
  }
  async salvarSistema(sistema: ListarSistemasModel): Promise<number> {
    try {
      return await lastValueFrom(
        this.http.put<ListarSistemasModel>(
          `${environment.apiSistema}/update`,
          JSON.stringify(sistema),
          this.httpOptions
        )
      ).then((res) => {
        return res.id;
      });

    } catch (error) {
      throw error;
    }
  }
  async salvarFuncionalidade(funcionalidade: FuncionalidadeModel): Promise<number> {
    try {
      return await lastValueFrom(
        this.http.post<FuncionalidadeModel>(
          `${environment.apiFuncionalidade}/create`,
          JSON.stringify(funcionalidade),
          this.httpOptions
        )
      ).then((res) => {
        return res.id;
      });

    } catch (error) {
      throw error;
    }
  }

  async salvarEditarFuncionalidade(funcionalidade: FuncionalidadeModel): Promise<number> {
    try {
      return await lastValueFrom(
        this.http.put<FuncionalidadeModel>(
          `${environment.apiFuncionalidade}/update`,
          JSON.stringify(funcionalidade),
          this.httpOptions
        )
      ).then((res) => {
        return res.id;
      });

    } catch (error) {
      throw error;
    }
  }
}
